var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-scroll',[(!_vm.$route.query.action || _vm.movedLocation || _vm.copiedLocation)?_c('single',{ref:"single",attrs:{"location-to-be-moved":_vm.movedLocation,"location-to-be-copied":_vm.copiedLocation}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }